module.exports = __webpack_public_path__ + "img/account_inner_white.d0034011.svg";